import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a ResizeObserver error
    const errorString = String(error);
    if (errorString.includes('ResizeObserver')) {
      // Don't update state for ResizeObserver errors - just ignore them
      return null;
    }
    
    // Update state for other errors
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log non-ResizeObserver errors
    const errorString = String(error);
    if (!errorString.includes('ResizeObserver')) {
      console.error('React Error Boundary caught an error:', error, errorInfo);
    }
    // Silently ignore ResizeObserver errors
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI for real errors
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Something went wrong</h2>
            <p className="text-gray-600 mb-4">Please refresh the page and try again.</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-[#4FC3F7] hover:bg-[#29B6F6] text-white px-4 py-2 rounded"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;